import { STORAGE_KEY, IDENTITY_KEY_NAME } from '@/constants';

const getValueByGlobalUser = {
  [IDENTITY_KEY_NAME.TOKEN]: () => window.GLOBAL_USERINFO[STORAGE_KEY.TOKEN],
  [IDENTITY_KEY_NAME.UID]: () => window.GLOBAL_USERINFO[STORAGE_KEY.STUDENT_ID],
  [IDENTITY_KEY_NAME.APP_VERSION]: () => window.GLOBAL_USERINFO[STORAGE_KEY.APP_VERSION],
  [IDENTITY_KEY_NAME.APP_NAME]: () => window.GLOBAL_USERINFO[STORAGE_KEY.APP_NAME],
  [IDENTITY_KEY_NAME.DEVICE_TYPE]: () => window.GLOBAL_USERINFO[STORAGE_KEY.DEVICE_TYPE],
};

export default getValueByGlobalUser;
